import { Expose, TransformPlainToClass } from 'class-transformer';

import { QueryParamsHandling } from '@angular/router';

import { ExposeRawData } from '@lib/common/decorators';

import { SnRouteConfig } from '../types';

export class SnRoute {
  @ExposeRawData()
  public link: string | any[];

  @Expose()
  public replaceUrl: boolean;

  @Expose()
  public skipLocationChange: boolean;

  @ExposeRawData()
  public state: { [key: string]: any };

  @Expose()
  public fragment: string;

  @Expose()
  public preserveFragment: boolean;

  @Expose()
  public target: string;

  @ExposeRawData()
  public queryParams: { [key: string]: any };

  @Expose()
  public queryParamsHandling: QueryParamsHandling;

  @TransformPlainToClass(SnRoute, { strategy: 'excludeAll' })
  public static fromConfig(config: SnRouteConfig): SnRoute {
    const data = typeof config === 'string' ? { link: config } : config;

    return data as SnRoute;
  }

  constructor() {}
}
